(function () {
  "use strict";

  angular.module("sempraWebapp").factory("DateTime", DateTimeFactory);

  /** @ngInject */
  function DateTimeFactory() {
    function DateTime(timestamp) {
      this.timestamp = timestamp ? timestamp : moment().valueOf();
    }

    DateTime.units = {
      DAY: "day",
      MONTH: "month",
      YEAR: "year"
    };

    DateTime.prototype.set = function (year, month, day) {
      this.timestamp = moment({
        years: year,
        months: month,
        date: day
      }).valueOf();
    };

    DateTime.prototype.startOf = function (unit) {
      this.timestamp = moment(this.timestamp).startOf(unit).valueOf();
      return this;
    };

    DateTime.prototype.endOf = function (unit) {
      this.timestamp = moment(this.timestamp).endOf(unit).valueOf();
      return this;
    };

    DateTime.prototype.addDays = function (days) {
      this.timestamp = moment(this.timestamp).add(days, "days").valueOf();
      return this;
    };

    DateTime.prototype.addMonths = function (months) {
      this.timestamp = moment(this.timestamp).add(months, "months").valueOf();
      return this;
    };

    DateTime.prototype.addYears = function (years) {
      this.timestamp = moment(this.timestamp).add(years, "years").valueOf();
      return this;
    };

    DateTime.prototype.listAllMonths = function () {
      var months = moment.months();
      var data = [];
      for (var i = 0; i < months.length; i++) {
        var temp = {
          id: i + 1,
          name: months[i]
        };
        data.push(temp);
      }

      return data;
    };

    DateTime.prototype.listHours = function () {
      var data = [];
      for (var i = 0; i < 25; i++) {
        data.push(i);
      }

      return data;
    };

    DateTime.prototype.convertDateForKarcherReports = function (currentDate, timestamp) {
      // Convert minutes to milliseconds and return new value
      return timestamp - (currentDate.getTimezoneOffset() * 60000);
    };

    DateTime.prototype.listYears = function () {
      var limit = 10;
      var currentYear = moment().year();
      var data = [];
      // push last 10 years
      for (var i = currentYear - limit; i <= currentYear; i++) {
        data.push(i);
      }
      return data;
    };

    return DateTime;
  }
})();
